/* eslint-disable react/require-default-props */
import { convertCriteriaGroupActivity } from '../../../../../../api/enumerations';
import { CriteriaAnalysisData } from '../../../../../../api/theHive/notices/types';
import { Constants } from '../../../../../../constants/hiveNotices';
import {
  ChangeRequestChip,
  CriteriaGroupBox,
  CriteriaGroupHeader,
  CriteriaGroupTitle,
} from '../styles';
import DocumentsTable from './DocumentsTable';

interface MemberEngineeringDocumentsProps {
  data: CriteriaAnalysisData;
  docLoading: boolean;
  handleReplace: (docId: number) => Promise<void>;
  handleApprove: (docId?: number) => Promise<void>;
  handleApproveWithReservation: (
    reservationNote: string,
    docId: number
  ) => Promise<void>;
  handleReject: (reason: string, docId?: number) => Promise<void>;
  disabled: boolean;
  hasOpenChangeRequest?: boolean;
  changeRequestDocIds?: Set<number>;
}

// Engineering analysis of ONE person: a table per criteria group they serve
// and a final table with whatever belongs to no requirement. The back end
// already delivers it grouped and scoped to the owner — nothing is crossed
// here.
export function MemberEngineeringDocuments({
  data,
  docLoading,
  handleReplace,
  handleApprove,
  handleApproveWithReservation,
  handleReject,
  disabled,
  hasOpenChangeRequest,
  changeRequestDocIds,
}: MemberEngineeringDocumentsProps): JSX.Element {
  const { groups, others } = data;

  return (
    <>
      {groups.map((group) => (
        <CriteriaGroupBox key={group.criteria_group_id}>
          <CriteriaGroupHeader>
            <CriteriaGroupTitle>
              {Constants.criteriaHeader
                .replace('{group}', group.group_name)
                .replace(
                  '{activity}',
                  convertCriteriaGroupActivity(group.activity)
                )
                .replace('{description}', group.criteria_description || '—')}
            </CriteriaGroupTitle>
            {group.pending_change_request_id !== null && (
              <ChangeRequestChip>
                {Constants.criteriaPendingRequest}
              </ChangeRequestChip>
            )}
          </CriteriaGroupHeader>
          <DocumentsTable
            name={group.group_name}
            hideTitle
            docList={group.documents}
            docLoading={docLoading}
            handleReplace={handleReplace}
            handleApprove={handleApprove}
            handleApproveWithReservation={handleApproveWithReservation}
            handleReject={handleReject}
            disabled={disabled}
            hasOpenChangeRequest={hasOpenChangeRequest}
            changeRequestDocIds={changeRequestDocIds}
          />
        </CriteriaGroupBox>
      ))}
      <CriteriaGroupBox>
        <CriteriaGroupHeader>
          <CriteriaGroupTitle>
            {Constants.otherDocumentsSection}
          </CriteriaGroupTitle>
        </CriteriaGroupHeader>
        <DocumentsTable
          name={Constants.otherDocumentsSection}
          hideTitle
          docList={others}
          emptyMessage={Constants.memberNoEngineeringDocuments}
          docLoading={docLoading}
          handleReplace={handleReplace}
          handleApprove={handleApprove}
          handleApproveWithReservation={handleApproveWithReservation}
          handleReject={handleReject}
          disabled={disabled}
          hasOpenChangeRequest={hasOpenChangeRequest}
          changeRequestDocIds={changeRequestDocIds}
        />
      </CriteriaGroupBox>
    </>
  );
}
